import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { FOOTER_GROUPS, PERSISTENT_RISK_LINE } from "@/data/site";

export const Footer = () => (
    <footer className="border-t border-haze bg-ink-soft">
        <div className="mx-auto w-full max-w-6xl px-5 py-16 sm:px-8">
            <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
                <div>
                    <Logo />
                    <p className="mt-4 max-w-xs text-sm leading-relaxed text-text-lo">
                        A disciplined, AI-driven day-trading engine for stocks
                        and futures. Deterministic analysis, transparent
                        decisions, computed risk.
                    </p>
                    <p className="mt-4 font-mono text-[11px] text-rule">
                        The line holds.
                    </p>
                </div>

                {FOOTER_GROUPS.map((g) => (
                    <div key={g.title}>
                        <h4 className="font-mono text-[11px] uppercase tracking-[0.18em] text-text-lo">
                            {g.title}
                        </h4>
                        <ul className="mt-4 space-y-3">
                            {g.links.map((l) => (
                                <li key={l.to}>
                                    <Link
                                        to={l.to}
                                        data-testid={`footer-${l.to.replace(/\//g, "-")}`}
                                        className="text-sm text-text-lo transition-colors hover:text-rule"
                                    >
                                        {l.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>

            <div className="mt-14 border-t border-haze pt-8">
                <p
                    data-testid="persistent-risk-line"
                    className="max-w-4xl text-xs leading-relaxed text-text-lo"
                >
                    {PERSISTENT_RISK_LINE}
                </p>
                <div className="mt-6 flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-center">
                    <p className="font-mono text-[11px] text-text-lo">
                        © {new Date().getFullYear()} The Aegis Line · Concept
                        site
                    </p>
                    <Link
                        to="/legal/risk-disclosure"
                        className="font-mono text-[11px] text-rule hover:text-text-hi"
                    >
                        Full risk disclosure →
                    </Link>
                </div>
            </div>
        </div>
    </footer>
);

export default Footer;
